import React, {Component} from 'react';
import Data from "./Data";
import $ from "jquery";
import axios from "axios";import {DialogContent, FormControlLabel, Switch} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import JalaliUtils from "@date-io/jalaali";
import moment from "moment";
import falocale from 'moment/locale/fa';
import jMoment from "moment-jalaali";
import ModalEditClassInfo from './ModalEditClassInfo';

class Classes2List extends Component {

    constructor(props) {
        super(props);
        this.state={
            studentname : this.props.products['studentname'],
            studentphone : this.props.products['studentphone'],
            reserved : this.props.products['reserved'],
            status : this.props.products['reserved']==="no"?true:false,
            reserve_time : this.props.products['reserve_time'],
            snerror : false,
            sperror : false,
            calenderopen : false,
            bderror: false,
            namefamily: this.props.products['studentname'],
            phone : this.props.products['studentphone'],
            birthday:this.props.products['reserve_time'],
            borndate:jMoment(this.props.products['reserve_time'],'jYYYY-jMM-jDD'),
            errors : {

            },
            editmodal:<div></div>
        }
    }

    collapse(id){
        $('#'+id).collapse('toggle');
    }
    handleDateChange(date){

        let borndate = moment(date).isValid()?date:"";
        let birthday = moment(date).isValid()?date.locale("en").format("jYYYY-jMM-jDD"):"";

        $('#waitspinner').modal('show');
        const {studentname,studentphone,reserved} = this.state;

        let data = new FormData();
        data.append('masterid',this.props.products['masterid']);
        data.append('dayid',this.props.products['dayid']);
        data.append('time',this.props.products['time']);
        data.append('studentname',studentname);
        data.append('studentphone',studentphone);
        data.append('reserved',reserved);
        data.append('reserve_time',birthday);


        axios.post(Data.server+'editClass.php',data)
            .then(response=>{

                $('#waitspinner').modal('hide');

                if (response.data === "ok") {
                    this.setState({
                        bderror: !moment(date).isValid(),
                        borndate: borndate,
                        birthday: birthday,
                    });
                }
                if (response.data.includes("error update")){
                    this.props.toast("خطای داخلی رخ داد",3000,"bg-danger",()=> {
                        $('#liveToast').toast('show');
                    });
                }

            })
            .catch(error=>{
                $('#waitspinner').modal('hide');
                console.log(error);
            });

        let date2 =moment(date).isValid()?date.locale("fa"):"";
    }

    handleCloseReg(e) {
        e.preventDefault();

        this.setState({
            openReg:false
        })
    };
    handleChange(event){
        let fields = this.state;
        let target = event.target;
        fields[target.name] = target.value;
        this.setState(fields);
    }
    handleChange2(event){
        let fields = this.state;
        let target = event.target;
        fields[target.name] = target.checked;
        $('#waitspinner').modal('show');
        const {studentname,studentphone,reserve_time} = this.state;

        let reserved = target.checked?"no":"yes";
        let data = new FormData();
        data.append('masterid',this.props.products['masterid']);
        data.append('dayid',this.props.products['dayid']);
        data.append('time',this.props.products['time']);
        data.append('studentname',studentname);
        data.append('studentphone',studentphone);
        data.append('reserved',reserved);
        data.append('reserve_time',reserve_time);


        axios.post(Data.server+'editClass.php',data)
            .then(response=>{

                $('#waitspinner').modal('hide');

                if (response.data === "ok") {

                    this.setState(fields);

                }
                if (response.data.includes("error update")){
                    this.props.toast("خطای داخلی رخ داد",3000,"bg-danger",()=> {
                        $('#liveToast').toast('show');
                    });
                }

            })
            .catch(error=>{
                $('#waitspinner').modal('hide');
                console.log(error);
            });
    }
    handleEditClassInfo(e,id,classid,products,index){
        this.setState({
            editmodal: <ModalEditClassInfo
            toast={this.props.toast.bind(this)}
            id={id}
            classid={classid}
            products={products}
            index={index} />
        }, () => {
            $("body").children().first().before($('#'+id));
            $('#'+id).modal('show');
            $('#'+id).on('hidden.bs.modal', function () {
                $('#'+id).remove();
            })
        });
        
    }
    render() {

        
        
        const {products,index} = this.props;
        const {studentname,status,birthday,borndate,bderror ,namefamily,phone,editmodal} = this.state;
        const {errors} = this.state;
        let classid = 'class'+products['id'];
        let id = 'editstudentclass'+products['id'];
        let classes = <p>در حال حاضر کلاسی ندارد</p>;
 

        return (
            <tr id={classid} key={index} className="text-center">
                <td>{products['day']+' ('+products['dayid']+')'}</td>
                <td>{products['time']}</td>
                <td>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={status}
                                onChange={this.handleChange2.bind(this)}
                                name="status"
                                color="primary"
                            />
                        }
                        label="فعال"
                    />
                </td>
                <td>
                    <MuiPickersUtilsProvider utils={JalaliUtils} locale={falocale}>
                        <KeyboardDatePicker
                            id="borndate"
                            className="w-100"
                            name="borndate"
                            inputProps={
                                {
                                    readOnly: true
                                }
                            }
                            variant="dialog"
                            labelFunc={date => moment(date).isValid()?date.format("jYYYY-jMM-jDD") : ""}
                            okLabel={"تایید"}
                            cancelLabel={"لغو"}
                            open={this.state.calenderopen}
                            inputVariant="outlined"
                            value={borndate}
                            type="borndate"
                            onClick={() => this.setState({calenderopen:true})}
                            onClose={() => this.setState({calenderopen:false})}
                            onChange={(date) => this.handleDateChange(date)}
                            label="تاریخ آخرین جلسه"
                            error={bderror}
                            helperText="لطفا تاریخ آخرین جلسه را وارد کنید"
                            margin="normal"
                        />
                    </MuiPickersUtilsProvider>

                </td>
                <td id={classid+"namephone"}>{products['studentname']}<br />{products['studentphone']}</td>
                <td>
                    <button 
                        type="button"
                        className="btn btn-sm btn-outline-info"
                        onClick={(e) => this.handleEditClassInfo(e,id,classid,products,index)}
                        data-toggle="modal"
                        data-target={"#"+id}>ویرایش</button>
                    
                </td>

                {editmodal}
                
            </tr>

        );
    }
}


export default Classes2List;
